<template>
    <ion-list>
        <ion-item v-for="n in rows" :key="n">
            <ion-thumbnail slot="start">
                <ion-skeleton-text/>
            </ion-thumbnail>
            <ion-label>
                <ion-skeleton-text animated style="height: 1em" :style="`width: ${randomWidth()}%`"/>
                <ion-skeleton-text animated :style="`width: ${randomWidth()}%`"/>
                <ion-skeleton-text animated :style="`width: ${randomWidth()}%`"/>
            </ion-label>
        </ion-item>
    </ion-list>
</template>

<script>
import {IonSkeletonText, IonList, IonItem, IonThumbnail, IonLabel} from '@ionic/vue';

export default {
    props: {rows: Number},
    name: "Skeleton",
    components: {IonSkeletonText, IonList, IonItem, IonThumbnail, IonLabel},
    methods: {
        randomWidth() {
            return 69 + Math.round((Math.random() * 30));
        }
    }
}
</script>

<style scoped>
ion-item div {
    display: block;
    width: 100%;
}
</style>
